/**
 * 用户相关操作
 */

// 登录
export const LOGIN = 'LOGIN';

// 注销
export const LOGOUT = 'LOGOUT';

//获取用户信息
export const GET_USERINFO = 'GET_USERINFO';

// 获取用户菜单权限列表
export const GET_USER_MENUS = 'GET_USER_MENUS'

// 获取用户最近投注信息
export const GET_USER_BET_RECENT = 'GET_USER_BET_RECENT';

// 清空用户最近投注信息
export const CLEAR_USER_BET_RECENT = 'CLEAR_USER_BET_RECENT';

// 用token换取旧版SESSION
export const GET_SESSION_BY_TOKEN = 'GET_SESSION_BY_TOKEN';

// 用session换token
export const GET_TOKEN_BY_SESSION = 'GET_TOKEN_BY_SESSION';

// 获取未读聊天条数
export const GET_UNREAD_CHAT_COUNT = 'GET_UNREAD_CHAT_COUNT';

// 从平台获取余额
export const GET_BALANCE_FROM_PLATFORM = 'GET_BALANCE_FROM_PLATFORM'

// 获取彩票余额
export const GET_BALANCE_FOR_LOTTERY = 'GET_BALANCE_FOR_LOTTERY';

// 平台转账
export const TRANSFER_BALANCE = 'TRANSFER_BALANCE'

// 修改密码
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'

// 标记平台不可用
export const MARK_PLATFORM_UNAVAILBLE = 'MARK_PLATFORM_UNAVAILBLE'

// 创建平台账号
export const CREATE_PLATFORM_ACCOUNT = 'CREATE_PLATFORM_ACCOUNT'

// 获取平台用户信息
export const GET_PLATFORM_PROFILE = 'GET_PLATFORM_PROFILE';

// 注册用户
export const REGISTER = 'REGISTER'

// 代理注册下级用户
export const  REGISTER_BY_AGENT = 'REGISTER_BY_AGENT'

// 检测资金密码是否正确
export const CHECK_SECURITY_PASS = 'CHECK_SECURITY_PASS'

// 验证密保问题
export const CHECK_SECURITY_QUESTION = 'CHECK_SECURITY_QUESTION'

// 设置修改密保问题
export const SET_SECURITY_QUESTIONS = 'SET_SECURITY_QUESTIONS'

// 修改提款密码
export const UPDATE_WITHDRAWAL_PASS = 'UPDATE_WITHDRAWAL_PASS'

//获取提款地址等信息
export const GET_WITHDRAWAL_LIST_USDT = 'GET_WITHDRAWAL_LIST_USDT'

//提款前置验证
export const CHECK_WITHDRAWAL_DATA_USDT = 'CHECK_WITHDRAWAL_DATA_USDT'
//usdt提款
export const WITHDRAWAL_USDT = 'WITHDRAWAL_USDT'

//usdt提款是否可用
export const CHECK_USDT_AVAILABLE = 'CHECK_USDT_AVAILABLE'

//获取电子钱包地址
export const GET_WALLET_LIST = 'GET_WALLET_LIST'

//获取币种地址
export const GET_COIN_TYPE_LIST = 'GET_COIN_TYPE_LIST'

//锁定钱包
export const LOCK_WALLET = 'LOCK_WALLET'

//重新绑定钱包前置验证
export const CHECK_REBIND = 'CHECK_REBIND'

//重新绑定钱包
export const MODIFY_WALLET_ADDRESS = 'CHECK_REBIND'

//验证最后一次绑定的钱包地址
export const CHECK_LAST_BIND = 'CHECK_LAST_BIND'

//绑定新钱包
export const BIND_NEW_WALLET = 'BIND_NEW_WALLET'

// 可用的提款方式
export const LEGAL_WITHDRAW_TYPE = 'LEGAL_WITHDRAW_TYPE'
// 获取安全钱包转账信息
export const GET_SAFTYWALLET_INFO = 'GET_SAFTYWALLET_INFO';

// 安全钱包转账确认
export const CHECK_SAFTYWALLEY_TRANSFERPOST = 'CHECK_SAFTYWALLEY_TRANSFERPOST';

// 获取用户是否支持安全钱包提款
export const SAFTYWALLET_SUPPORT = 'SAFTYWALLET_SUPPORT';

// 获取安全钱包提款信息
export const GET_SAFTYWALLEY_WITHDRAWAL = 'GET_SAFTYWALLEY_WITHDRAWAL';

// 安全钱包提款信息确认
export const CONFIRM_SAFTYWALLET_INFO = 'CONFIRM_SAFTYWALLET_INFO';

// 提交安全钱包提款
export const SBUMIT_SAFTYWALLET_INFP = 'SBUMIT_SAFTYWALLET_INFP';
